/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue } from "@utils/lodash";
import NoAccessPage from "@components/common/NoAccess";
import moment from "moment";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { json2array, textCapitalize } from "@_common/text-helpers";
import {
  getDashboardLicenceActivity,
  getDashboardLicenceDailyCount,
  getDashboardLicenceLocationLicenceType,
  getDashboardLicenceLocations,
  getDashboardLicenceRenewals,
  getDashboardLicenceRenewalsFunctions,
  getDashboardLicenceValid,
  getDashboardLicenceValidFunctions,
} from "@services/dashboard.service";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { formatText } from "@_common/format-text";
// import "./index.scss";
import LicenseExpandableTable from "@components/Dashboard/licenseExpandableTable";
import { getDashboardLicenceCurrentStats } from "../../../services/dashboard.service";
import InputField from "@_common/InputRuleFeild";
import { months } from "@_common/month";
import { Bar } from "react-chartjs-2";
import zoomPlugin from "chartjs-plugin-zoom";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  ArcElement,
} from "chart.js";
import "chartjs-plugin-datalabels";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { adminGetListManagementGroupCode } from "@services/list-management.service";
import { CheckDecimal } from "@_common/check-decimal";
import Loader from "@components/common/Loader";
import DashboardSvgComponent from "../../../assets/svg-components/left-menu/dashboard";
import ExecutorTaskNotFoundSvgComponent from "../../../assets/svg-components/not-found/executor-task";
import ValidLicenseExpandableTable from "@components/Dashboard/validLicenseExpandableTable";
import RenewalsLicenseExpandableTable from "@components/Dashboard/RenewalsLicenseExpandableTable";
import { convertCurrentDate } from "@_common/date-helpers";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels,
  LineElement,
  PointElement,
  ArcElement,
  zoomPlugin
);
export default function Licence(props: any) {
  const navigate = useNavigate();
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const random_rgba = () => {
    const colors = [
      "#E8F0FE",
      "#F0F9F6",
      "#FDF9F4",
      "#D8E6FE",
      "#FBF2F4",
      "#FFFCFC",
      "#FDFEFF",
    ];
    var random_color: any = colors[Math.floor(Math.random() * colors.length)];
    return random_color;
  };

  const [from_date, setFirstDay] = React.useState(new Date());
  const [to_date, setLastDay] = React.useState(new Date());
  const [isLoading, setIsLoading] = React.useState(true);
  const [unitLicenseDetails, setActivityList] = React.useState([]);
  const [upcomingRenewals, setOpenList] = React.useState([]);
  const [yearList, setYearList] = React.useState([]);
  const [isAllTime, setIsAllTime] = React.useState("false");

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  React.useEffect(() => {
    getLicenseTypeInfo();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getActivityInfo();
      getLocationInfo();
      getValidLicenseLocations();
      getRenewalsLocations();
      getCurrentLicenseStats();
    }
    let currentYear: any = "2021";
    let count = new Date().getFullYear() + 1;
    let yearList: any = [];
    Array.from({ length: count }, (v, k) => k).map((k) => {
      if (k >= currentYear) {
        return yearList.push({
          value: `${k}`,
          label: `${k}`,
        });
      }
    });
    setYearList(yearList);
    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
    setFirstDay(from_date);
    setLastDay(to_date);
  }, [props.permissionAPITriggered]);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getActivityInfo();
      getLocationInfo();
      getValidLicenseLocations();
      getRenewalsLocations();
      getCurrentLicenseStats();
      // if (getValue(params, `license_type_id`, "")) {
      //   getLicenseDailyCount(getValue(params, `license_type_id`, ""));
      // }
      if (params.from_date && params.to_date) {
        var firstDay = new Date(params.from_date);
        var lastDay = new Date(params.to_date);
        setFirstDay(firstDay);
        setLastDay(lastDay);
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  React.useEffect(() => {
    if (isAllTime) {
      getActivityInfo();
      getLocationInfo();
      // getCurrentLicenseStats();
      getRenewalsLocations();
      getValidLicenseLocations();
    }
  }, [isAllTime]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const [licenseTypeList, setLicenseTypeList] = React.useState([]);
  const [selectedLicenseType, setSelectedLicenseType] = React.useState("");
  const getLicenseTypeInfo = async () => {
    let payload: any = {
      page_no: 1,
      page_size: 100,
    };
    let queryRequest = QueryRequestHelper(payload);
    let licenseType = await adminGetListManagementGroupCode("license-type");

    if (licenseType) {
      let licenseTypeList =
        getValue(licenseType, `data.listItems.length`, 0) > 0
          ? getValue(licenseType, `data.listItems`, []).filter((item: object) =>
            getValue(item, `is_active`, "")
          )
          : [];
      let list = licenseTypeList.map((item: object) => ({
        value: getValue(item, `text`, ""),
        label: getValue(item, `text`, ""),
        id: getValue(item, `id`, ""),
      }));
      setLicenseTypeList(list);
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      if (getValue(params, `license_type_id`, "")) {
        // getLicenseDailyCount(getValue(params, `license_type_id`, ""));
        setSelectedLicenseType(getValue(params, `license_type_id`, ""));
      } else {
        // getLicenseDailyCount(getValue(list, `[${0}].id`, ""));
        setSelectedLicenseType(getValue(list, `[${0}].id`, ""));
      }
    }
  };

  const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.checked ? "true" : "false";
    setIsAllTime(newValue);
  };

  const getActivityInfo = async () => {
    try {
      setIsLoading(true);
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let dates = params.date ? new Date(params.date) : new Date();
      var from_date = params.from_date
        ? params.from_date
        : new Date(dates.getFullYear(), dates.getMonth(), 1);
      var to_date = params.to_date
        ? params.to_date
        : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
      let payload: any = {
        // from_date: moment(from_date).format("YYYY-MM-DD"),
        // to_date: moment(to_date).format("YYYY-MM-DD"),
        from_date:
          isAllTime === "true" ? "" : moment(from_date).format("YYYY-MM-DD"),
        to_date:
          isAllTime === "true" ? "" : moment(to_date).format("YYYY-MM-DD"),
        all_time: isAllTime,
      };

      if (getValue(props, `permissions`, []).includes("view_all")) {
        payload.is_user_request = "false";
      }

      let queryRequest = QueryRequestHelper(payload);
      let resp = await getDashboardLicenceActivity(queryRequest);
      if (resp) {
        let activity = json2array(
          getValue(resp, `data.unit_license_details`, {})
        );
        let act = activity.map((item: any) => ({
          ...item,
          activity: Object.keys(item)[0],
        }));
        let open = json2array(getValue(resp, `data.upcoming_renewals`, {}));
        let op = open.map((item: any) => ({
          ...item,
          activity: Object.keys(item)[0],
        }));
        setActivityList(act);
        setOpenList(op);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  // location wise compliance
  const [licenseLocations, setComplianceLocations] = React.useState([]);
  const [functions, setFunctions] = React.useState([]);
  const getLocationInfo = async () => {
    try {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let dates = params.date ? new Date(params.date) : new Date();
      var from_date = params.from_date
        ? params.from_date
        : new Date(dates.getFullYear(), dates.getMonth(), 1);
      var to_date = params.to_date
        ? params.to_date
        : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

      let payload: any = {
        // from_date: moment(from_date).format("YYYY-MM-DD"),
        // to_date: moment(to_date).format("YYYY-MM-DD"),
        from_date:
          isAllTime === "true" ? "" : moment(from_date).format("YYYY-MM-DD"),
        to_date:
          isAllTime === "true" ? "" : moment(to_date).format("YYYY-MM-DD"),
        all_time: isAllTime,
      };

      if (getValue(props, `permissions`, []).includes("view_all")) {
        payload.is_user_request = "false";
      }

      let queryRequest = QueryRequestHelper(payload);
      let resp = await getDashboardLicenceLocations(queryRequest);
      if (resp) {
        let response = json2array(getValue(resp, `data`, []));
        let responseHeaders: any = Object.keys(getValue(resp, `data`, []));

        // Filter out locations where all counts are 0
        const filteredResponse = response.filter((item: any) => {
          const locationKey = Object.keys(item)[0];
          const locationData = item[locationKey];

          // Check if any count is greater than 0
          return (
            getValue(locationData, "total.count", 0) > 0 ||
            getValue(locationData, "valid_license.count", 0) > 0 ||
            getValue(locationData, "expired_license.count", 0) > 0 ||
            getValue(locationData, "upcoming_license.count", 0) > 0
          );
        });

        setComplianceLocations(
          getValue(filteredResponse, `length`, 0) > 0 &&
          filteredResponse.map((item: any) => ({
            id: item[Object.entries(item)[0][0]].location_id,
            location: Object.keys(item)[0].split("::")[0],
            auditData: item[Object.entries(item)[0][0]],
          }))
        );
      } else {
      }
    } catch (error) { }
  };

  //Valid License
  const [validLicenseLocations, setValidLicenseLocations] = React.useState([]);
  const getValidLicenseLocations = async () => {
    try {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let dates = params.date ? new Date(params.date) : new Date();
      var from_date = params.from_date
        ? params.from_date
        : new Date(dates.getFullYear(), dates.getMonth(), 1);
      var to_date = params.to_date
        ? params.to_date
        : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

      let payload: any = {
        // from_date: moment(from_date).format("YYYY-MM-DD"),
        // to_date: moment(to_date).format("YYYY-MM-DD"),
        from_date:
          isAllTime === "true" ? "" : moment(from_date).format("YYYY-MM-DD"),
        to_date:
          isAllTime === "true" ? "" : moment(to_date).format("YYYY-MM-DD"),
        all_time: isAllTime,
      };

      if (getValue(props, `permissions`, []).includes("view_all")) {
        payload.is_user_request = "false";
      }

      let queryRequest = QueryRequestHelper(payload);
      let resp = await getDashboardLicenceValid(queryRequest);
      if (resp) {
        setValidLicenseLocations(getValue(resp, `data`, []));
      } else {
      }
    } catch (error) { }
  };

  const [validLicenseLocationsFunctions, setValidLicenseLocationsFunctions] =
    React.useState([]);
  const [
    validLicenseLocationsFunctionsLoading,
    setValidLicenseLocationsFunctionsLoading,
  ] = React.useState(false);

  const getValidLicenseLocationsFunctions = async (id: string) => {
    if (id) {
      try {
        setValidLicenseLocationsFunctionsLoading(true);
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        let dates = params.date ? new Date(params.date) : new Date();
        var from_date = params.from_date
          ? params.from_date
          : new Date(dates.getFullYear(), dates.getMonth(), 1);
        var to_date = params.to_date
          ? params.to_date
          : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

        let payload = {
          from_date: moment(from_date).format("YYYY-MM-DD"),
          to_date: moment(to_date).format("YYYY-MM-DD"),
        };
        let queryRequest = QueryRequestHelper(payload);

        let resp = await getDashboardLicenceValidFunctions(id);
        if (resp) {
          // let response = json2array(getValue(resp, `data`, []));
          // setFunctions(
          //   getValue(response, `length`, 0) > 0 &&
          //     response.map((item: any) => ({
          //       id: item[Object.entries(item)[0][0]].function_id,
          //       location: Object.keys(item)[0].split("::")[0],
          //       auditData: item[Object.entries(item)[0][0]],
          //     }))
          // );
          // let responseHeaders: any = Object.keys(getValue(resp, `data`, {}));

          // setLicenseHeaders(responseHeaders);
          setValidLicenseLocationsFunctions(getValue(resp, `data`, []));
          setValidLicenseLocationsFunctionsLoading(false);
        } else {
          setValidLicenseLocationsFunctions([]);
          setValidLicenseLocationsFunctionsLoading(false);
        }
      } catch (error) {
        setValidLicenseLocationsFunctions([]);
        setValidLicenseLocationsFunctionsLoading(false);
      }
    } else {
    }
  };

  //Renewals
  const [renewalsLocations, setRenewalsLocations] = React.useState([]);
  const getRenewalsLocations = async () => {
    try {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let dates = params.date ? new Date(params.date) : new Date();
      var from_date = params.from_date
        ? params.from_date
        : new Date(dates.getFullYear(), dates.getMonth(), 1);
      var to_date = params.to_date
        ? params.to_date
        : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

      let payload: any = {
        // from_date: moment(from_date).format("YYYY-MM-DD"),
        // to_date: moment(to_date).format("YYYY-MM-DD"),
        from_date:
          isAllTime === "true" ? "" : moment(from_date).format("YYYY-MM-DD"),
        to_date:
          isAllTime === "true" ? "" : moment(to_date).format("YYYY-MM-DD"),
        all_time: isAllTime,
      };

      if (getValue(props, `permissions`, []).includes("view_all")) {
        payload.is_user_request = "false";
      }

      let queryRequest = QueryRequestHelper(payload);
      let resp = await getDashboardLicenceRenewals(queryRequest);
      if (resp) {
        setRenewalsLocations(getValue(resp, `data`, []));
      } else {
      }
    } catch (error) { }
  };

  const [renewalsLocationsFunctions, setRenewalsLocationsFunctions] =
    React.useState([]);
  const [
    renewalsLocationsFunctionsLoading,
    setRenewalsLocationsFunctionsLoading,
  ] = React.useState(false);

  const getRenewalsLocationsFunctions = async (id: string) => {
    if (id) {
      try {
        setRenewalsLocationsFunctionsLoading(true);
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        let dates = params.date ? new Date(params.date) : new Date();
        var from_date = params.from_date
          ? params.from_date
          : new Date(dates.getFullYear(), dates.getMonth(), 1);
        var to_date = params.to_date
          ? params.to_date
          : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

        let payload: any = {
          // from_date: moment(from_date).format("YYYY-MM-DD"),
          // to_date: moment(to_date).format("YYYY-MM-DD"),
          from_date:
            isAllTime === "true" ? "" : moment(from_date).format("YYYY-MM-DD"),
          to_date:
            isAllTime === "true" ? "" : moment(to_date).format("YYYY-MM-DD"),
          all_time: isAllTime,
        };

        if (getValue(props, `permissions`, []).includes("view_all")) {
          payload.is_user_request = "false";
        }

        let queryRequest = QueryRequestHelper(payload);

        let resp = await getDashboardLicenceRenewalsFunctions(id, queryRequest);
        if (resp) {
          setRenewalsLocationsFunctions(getValue(resp, `data`, []));
          setRenewalsLocationsFunctionsLoading(false);
        } else {
          setRenewalsLocationsFunctions([]);
          setRenewalsLocationsFunctionsLoading(false);
        }
      } catch (error) {
        setRenewalsLocationsFunctions([]);
        setRenewalsLocationsFunctionsLoading(false);
      }
    } else {
    }
  };

  const [child_loading, setChild_loading] = React.useState(false);
  const [licenseHeaders, setLicenseHeaders] = React.useState([]);
  const getLocationFunctions = async (id: string) => {
    if (id) {
      try {
        setChild_loading(true);
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        let dates = params.date ? new Date(params.date) : new Date();
        var from_date = params.from_date
          ? params.from_date
          : new Date(dates.getFullYear(), dates.getMonth(), 1);
        var to_date = params.to_date
          ? params.to_date
          : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

        let payload = {
          from_date: moment(from_date).format("YYYY-MM-DD"),
          to_date: moment(to_date).format("YYYY-MM-DD"),
          location_id: id,
        };
        let queryRequest = QueryRequestHelper(payload);

        let resp = await getDashboardLicenceLocationLicenceType(queryRequest);
        if (resp) {
          let response = json2array(getValue(resp, `data`, []));
          setFunctions(
            getValue(response, `length`, 0) > 0 &&
            response.map((item: any) => ({
              id: item[Object.entries(item)[0][0]].function_id,
              location: Object.keys(item)[0].split("::")[0],
              auditData: item[Object.entries(item)[0][0]],
            }))
          );
          let responseHeaders: any = Object.keys(getValue(resp, `data`, {}));

          setLicenseHeaders(responseHeaders);
          setChild_loading(false);
        } else {
          setFunctions([]);
          setChild_loading(false);
        }
      } catch (error) {
        setFunctions([]);
        setChild_loading(false);
      }
    } else {
    }
  };

  const [licenseStats, setLicenseStats] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const getCurrentLicenseStats = async () => {
    try {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let dates = params.date ? new Date(params.date) : new Date();
      var from_date = params.from_date
        ? params.from_date
        : new Date(dates.getFullYear(), dates.getMonth(), 1);
      var to_date = params.to_date
        ? params.to_date
        : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

      let payload: any = {
        // from_date: moment(from_date).format("YYYY-MM-DD"),
        // to_date: moment(to_date).format("YYYY-MM-DD"),
        from_date:
          isAllTime === "true" ? "" : moment(from_date).format("YYYY-MM-DD"),
        to_date:
          isAllTime === "true" ? "" : moment(to_date).format("YYYY-MM-DD"),
        all_time: isAllTime,
      };

      if (getValue(props, `permissions`, []).includes("view_all")) {
        payload.is_user_request = "false";
      }

      let queryRequest = QueryRequestHelper(payload);
      let resp = await getDashboardLicenceCurrentStats(queryRequest);
      if (resp) {
        let response = json2array(getValue(resp, `data`, []));

        // Filter out license types where both counts are 0
        const filteredResponse = response.filter((item: any) => {
          const licenseKey = Object.keys(item)[0];
          const licenseData = item[licenseKey];

          // Check if either followup_today or new count is greater than 0
          return (
            getValue(licenseData, "followup_today.count", 0) > 0 ||
            getValue(licenseData, "new.count", 0) > 0
          );
        });

        setLicenseStats(
          getValue(filteredResponse, `length`, 0) > 0 &&
          filteredResponse.map((item: any) => ({
            id: item[Object.entries(item)[0][0]].license_type_id,
            license: Object.keys(item)[0],
            data: item[Object.entries(item)[0][0]],
          }))
        );
      } else {
      }
    } catch (error) { }
  };

  const randomColor = () => {
    var color = Math.floor(Math.random() * 16777216).toString(16);
    // Avoid loops.
    return "#000000".slice(0, -color.length) + color;
  };

  const getLicenseDailyCount = async (id: string) => {
    try {
      setLoading(true);
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      var year = params.year ? params.year : new Date().getFullYear();
      var month: any = params.month ? params.month : new Date().getMonth() + 1;
      let payload = {
        year: year,
        month: parseInt(month),
        license_type_id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getDashboardLicenceDailyCount(queryRequest);
      if (resp) {
        let labels: any = [];
        let response = json2array(getValue(resp, `data`, {}));
        labels =
          getValue(response, `length`, 0) > 0 &&
          response.map((item: any) => Object.keys(item));
        let finalLabels = [].concat(...labels);
        let count: any = [];
        let colors: any = [];
        for (let i = 0; i < getValue(response, `length`, 0); i++) {
          count.push(
            CheckDecimal(getValue(response, `[${i}]${labels[i]}.count`, 0))
          );
          colors.push(randomColor());
        }
        setDailyCountData({
          ...dailyCountData,
          labels: getValue(finalLabels, `length`, 0) > 0 ? finalLabels : [],
          datasets: [
            {
              label: "Daily Count",
              data: count,
              backgroundColor: colors,
              barThickness: 70,
            },
          ],
        });
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                              Date Routes                                   */
  /* -------------------------------------------------------------------------- */
  const handleDate = (date: any) => {
    setFirstDay(date[0]);
    setLastDay(date[1]);
  };
  const handleSubmitDate = () => {
    let first = moment(from_date).format("YYYY-MM-DD");
    let last = moment(to_date).format("YYYY-MM-DD");
    if (first && last && first !== "Invalid date" && last !== "Invalid date") {
      let payload: any = {
        from_date: first,
        to_date: last,
      };
      if (payload.from_date && payload.to_date) {
        let queryRequest = QueryRequestHelper(payload);
        navigate(`${window.location.pathname}?${queryRequest}`);
      } else {
        toast.error("Start Date and End Date Required");
      }
    } else {
      toast.error("Please select date");
    }
  };

  // category wise compliance chart
  const handleChangeDate = (e: string, value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    if (value === "year") {
      let payload: any = {
        ...params,
        year: e,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else if (value === "license_type_id") {
      let payload: any = {
        ...params,
        license_type_id: e,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      let payload: any = {
        ...params,
        month: e,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  // const params = React.useMemo(
  //   () =>
  //     Object.fromEntries(new URLSearchParams(window.location.search).entries()),
  //   [window.location.search]
  // );

  /* -------------------------------------------------------------------------- */
  /*                                 Chart section                              */
  /* -------------------------------------------------------------------------- */

  const options: any = {
    responsive: true,
    plugins: {
      datalabels: {
        anchor: "start",
        align: "end",
        labels: {
          value: {
            color: "black",
          },
        },
        // formatter: (val: any) => {
        // 	return val + "%";
        // },
      },
      legend: {
        position: "top",
      },
      title: {
        display: false,
        // text: "Chart.js Bar Chart",
      },
      zoom: {
        pan: {
          enabled: true,
          mode: "x",
        },
        zoom: {
          pinch: {
            enabled: true, // Enable pinch zooming
          },
          wheel: {
            enabled: true, // Enable wheel zooming
          },
          mode: "x",
        },
      },
    },
  };
  const [dailyCountData, setDailyCountData] = React.useState<any>({
    labels: [],
    datasets: [
      {
        label: "Day 1",
        data: [0, 0],
        backgroundColor: "rgba(53, 162, 235, 0.5)",
        barThickness: 10,
      },
    ],
  });

  const handleNavigateCompliance = (
    complianceId: string,
    type: string,
    value: String
    // compliance_task_id: any
  ) => {
    // let compliance_task_ids =
    // 	getValue(compliance_task_id, `length`, 0) > 0 ? compliance_task_id : [];
    var firstDay = params.from_date
      ? params.from_date
      : new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    var lastDay = params.to_date
      ? params.to_date
      : new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);

    let payload = {
      request_from: "dashboard",
      request_type: type,
      request_value: value,
      firstDay: moment(firstDay).format("YYYY-MM-DD"),
      lastDay: moment(lastDay).format("YYYY-MM-DD"),
      isAllTime,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`/activities/task/license/list/${complianceId}?${queryRequest}`);
  };

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
        !getValue(props, `subTabPermissionList`, []).includes(
          "dashboard_license"
        ) ? (
        <NoAccessPage />
      ) : isLoading || !props.permissionAPITriggered ? (
        <Loader />
      ) : (
        <>
          {/* <div className="dashboard-wrapper__header">
						<h4 className="dashbaord-wrapper__header-title">License</h4>
					</div> */}

          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <DashboardSvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Dashboard
                </h6>
                <h4 className="dashbaord-wrapper__header-title">License</h4>
              </div>
            </div>
          </div>

          <div
            className={`main-page-layout-wrapper main-page-layout-wrapper-dashboard`}
          >
            <div className="overview-wrapper">
              <div className="dashboard-compliance">
                <div className="dashboard-compliance__common d-flex align-items-center justify-content-between">
                  <h3 className="dashboard-compliance__title">
                    Upcoming Renewals
                  </h3>
                  <h3 className="dashboard-compliance__date dashboard-compliance__date--compliance overview-wrapper__header-date d-flex align-items-center">
                    {/* Jan 22, 2021 - Jan 22, 2022
										<img src="/images/arrow-drop.svg" className="img-fluid" /> */}

                    <div className="d-flex align-items-center flex-nowrap mx-2">
                      <h4
                        className="header_text__blue mb-0 me-2"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        All Time
                      </h4>
                      <div className="choicelist-wrapper custom-switch-wrapper">
                        <label className="switch mb-0">
                          <input
                            type="checkbox"
                            checked={isAllTime === "true"}
                            onChange={handleToggle}
                          />
                          <span className="slider round"></span>
                        </label>
                      </div>
                    </div>
                    <RightMenuHeaders
                      // mappedTaskSCExecutor={false}
                      // date range
                      dateRange={true}
                      from_date={from_date}
                      to_date={to_date}
                      handleDate={handleDate}
                      handleSubmitDate={handleSubmitDate}
                      // use license-style separate day pickers
                      licenseStyleCalendar={true}
                      //search
                      // isSearch={true}


                    />
                  </h3>
                </div>

                <div className="d-flex align-items-center box-gap mb-3">
                  {upcomingRenewals.some((obj: any) => {
                    const activityKey = getValue(obj, "activity", "");
                    const count = getValue(obj, `[${activityKey}].count`, 0);
                    return count > 0;
                  }) ? (
                    upcomingRenewals.map((obj: any, index: number) => {
                      const activityKey = getValue(obj, "activity", "");
                      const count = getValue(obj, `[${activityKey}].count`, 0);

                      if (count === 0) return null;

                      return (
                        <section
                          key={index}
                          className={`breakup-box breakup-box--${obj.color} breakup-box--${obj.background}`}
                          style={{ backgroundColor: random_rgba() }}
                          onClick={() =>
                            handleNavigateCompliance(
                              "id",
                              "upcoming_renewals",
                              activityKey
                            )
                          }
                        >
                          <div className="breakup-box__details">
                            <h6
                              className={`breakup-box__title breakup-box__title--${obj.color}`}
                            >
                              {count}
                            </h6>
                            <p
                              className={`breakup-box__text breakup-box__text--${obj.color}`}
                            >
                              {textCapitalize(formatText(activityKey))}
                            </p>
                          </div>
                          <img
                            src={obj.image}
                            className="img-fluid breakup-box-image"
                          />
                        </section>
                      );
                    })
                  ) : (
                    <div className="new-not-found-wrap w-100">
                      <div className="new-not-found-wrap__details">
                        <div className="not-found-image img-fluid not-found-image-executor-task">
                          <ExecutorTaskNotFoundSvgComponent />
                        </div>
                        <p className="no-data-found-text">
                          No record found for selected timeframe.
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="dashboard-compliance">
                {/* <div className="dashboard-compliance__outlook d-flex align-items-center justify-content-between w-100">
									<h3 className="dashboard-compliance__title">
										Unit License Details
									</h3>
									<h3 className="dashboard-compliance__date overview-wrapper__header-date d-flex align-items-center">
								Jan 22, 2021 - Jan 22, 2022<img src="/images/arrow-drop.svg" className="img-fluid" />
							</h3>
								</div> */}
                <div className="dashboard-compliance__common d-flex align-items-center justify-content-between">
                  <h3 className="dashboard-compliance__title">
                    Unit License Details
                  </h3>
                </div>

                {/* <div className="d-flex align-items-center box-gap mb-3">
									{unitLicenseDetails.map((obj: any, index) => {
										const activityKey = getValue(obj, 'activity', '');
										const count = getValue(obj, `[${activityKey}].count`, 0);
									
										if (count === 0) return null; // Skip rendering										
										return (
											<section
												key={index}
												className={`breakup-box breakup-box--${obj.color} breakup-box--${obj.background}`}
												style={{ backgroundColor: random_rgba() }}
												onClick={() =>
													getValue(
														obj,
														`[${getValue(obj, `activity`, "")}].count`,
														0
													) > 0 &&
													handleNavigateCompliance(
														"id",
														"unit_license_details",
														getValue(obj, `activity`, "")
													)
												}
											>
												<div className="breakup-box__details">
													<h6
														className={`breakup-box__title breakup-box__title--${obj.color}`}
													>
														{getValue(
															obj,
															`[${getValue(obj, `activity`, "")}].count`,
															""
														)}
													</h6>
													<p
														className={`breakup-box__text breakup-box__text--${obj.color}`}
													>
														{textCapitalize(
															formatText(getValue(obj, `activity`, ""))
														)}
													</p>
												</div>
												<img
													src={obj.image}
													className="img-fluid breakup-box-image"
												/>
											</section>
										);
									})}
								</div> */}

                <div className="d-flex align-items-center box-gap mb-3">
                  {unitLicenseDetails.some((obj: any) => {
                    const activityKey = getValue(obj, "activity", "");
                    const count = getValue(obj, `[${activityKey}].count`, 0);
                    return count > 0;
                  }) ? (
                    unitLicenseDetails.map((obj: any, index: number) => {
                      const activityKey = getValue(obj, "activity", "");
                      const count = getValue(obj, `[${activityKey}].count`, 0);

                      if (count === 0) return null;

                      return (
                        <section
                          key={index}
                          className={`breakup-box breakup-box--${obj.color} breakup-box--${obj.background}`}
                          style={{ backgroundColor: random_rgba() }}
                          onClick={() =>
                            handleNavigateCompliance(
                              "id",
                              "unit_license_details",
                              activityKey
                            )
                          }
                        >
                          <div className="breakup-box__details">
                            <h6
                              className={`breakup-box__title breakup-box__title--${obj.color}`}
                            >
                              {count}
                            </h6>
                            <p
                              className={`breakup-box__text breakup-box__text--${obj.color}`}
                            >
                              {textCapitalize(formatText(activityKey))}
                            </p>
                          </div>
                          <img
                            src={obj.image}
                            className="img-fluid breakup-box-image"
                          />
                        </section>
                      );
                    })
                  ) : (
                    <div className="new-not-found-wrap w-100">
                      <div className="new-not-found-wrap__details">
                        <div className="not-found-image img-fluid not-found-image-executor-task">
                          <ExecutorTaskNotFoundSvgComponent />
                        </div>
                        <p className="no-data-found-text">
                          No record found for selected timeframe.
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="w-100" style={{ display: "none" }}>
                <div className="loaction-wise-wrapper">
                  <div className="overview-wrapper__header d-flex align-items-center justify-content-between overview-wrapper__header-sm-mb">
                    <h3 className="overview-wrapper__header-title">
                      Upcoming Renewals - Location Wise
                    </h3>
                  </div>
                  <LicenseExpandableTable
                    locations={licenseLocations}
                    handleClickRow={getLocationFunctions}
                    functions={functions}
                    child_loading={child_loading}
                    headers={[
                      "Location",
                      "Expired License",
                      "Valid License",
                      "Upcoming License",
                      "Total",
                    ]}
                  />
                </div>
              </div>

              <div className="w-100">
                <div className="loaction-wise-wrapper">
                  <div className="overview-wrapper__header d-flex align-items-center justify-content-between overview-wrapper__header-sm-mb">
                    <h3 className="overview-wrapper__header-title">
                      Location Wise - Valid License
                    </h3>
                  </div>
                  <ValidLicenseExpandableTable
                    locations={validLicenseLocations}
                    handleClickRow={getValidLicenseLocationsFunctions}
                    functions={validLicenseLocationsFunctions}
                    child_loading={validLicenseLocationsFunctionsLoading}
                    headers={[
                      "Location",
                      // "Expired License",
                      "Valid License",
                      // "Upcoming License",
                      // "Total",
                    ]}
                  />
                </div>
              </div>

              <div className="w-100">
                <div className="loaction-wise-wrapper">
                  <div className="overview-wrapper__header d-flex align-items-center justify-content-between overview-wrapper__header-sm-mb">
                    <h3 className="overview-wrapper__header-title">
                      Location Wise - Renewals
                    </h3>
                    <div className="d-flex align-items-center">
                      {isAllTime === "true"
                        ? "All Time"
                        : `${convertCurrentDate(
                          from_date || params.from_date
                        )?.toString()} - ${convertCurrentDate(
                          to_date || params.to_date
                        )?.toString()}`}
                    </div>
                  </div>
                  <RenewalsLicenseExpandableTable
                    locations={renewalsLocations}
                    handleClickRow={getRenewalsLocationsFunctions}
                    functions={renewalsLocationsFunctions}
                    child_loading={renewalsLocationsFunctionsLoading}
                    headers={[
                      "Location",
                      // "Expired License",
                      "Renewals",
                      // "Upcoming License",
                      // "Total",
                    ]}
                  />
                </div>
              </div>

              <div className="w-100 d-none">
                <div className="loaction-wise-wrapper">
                  <div className="overview-wrapper__header d-flex align-items-center justify-content-between overview-wrapper__header-sm-mb">
                    <h3 className="overview-wrapper__header-title">
                      License Wise Status/Daily Count
                    </h3>
                  </div>
                  <div className="vendor-graph">
                    <Bar options={options} data={dailyCountData} height={70} />
                  </div>
                  <p className="text-center">
                    {loading ? "Please wait..." : ""}
                  </p>
                  <div className="overview-wrapper__header vendor-graph-border p-3 m-0 rounded-bottom">
                    <div className="filter-form-wrappper__container d-flex">
                      <div className="grid">
                        <div className="input-grid-item mt-0 dd-small-width-year">
                          <div className="filter-form-wrappper__location-form-group form-group mb-0">
                            {/* <label
															htmlFor="State"
															className="filter-form-wrappper__label"
														>
															Year
														</label> */}
                            <div className="filter-form-wrappper__location-input">
                              <InputField
                                inputType="INPUT_REACT_SELECT_MODAL"
                                placeholder="Choose Year"
                                className="form-control w-100"
                                name="state_id"
                                id="state_id"
                                options={yearList}
                                value={yearList.filter(
                                  (item: any) =>
                                    getValue(item, `value`, "") ==
                                    (getValue(params, `year`, "")
                                      ? getValue(params, `year`, "")
                                      : new Date().getFullYear())
                                )}
                                onChange={(e: any) =>
                                  handleChangeDate(
                                    getValue(e, `value`, ""),
                                    "year"
                                  )
                                }
                                isClear
                              />
                            </div>
                          </div>
                        </div>
                        &nbsp;&nbsp;&nbsp;
                        <div className="input-grid-item mt-0 dd-small-width-month">
                          <div className="filter-form-wrappper__location-form-group form-group mb-0">
                            {/* <label
															htmlFor="State"
															className="filter-form-wrappper__label"
														>
															Month
														</label> */}
                            <div className="filter-form-wrappper__location-input">
                              <InputField
                                inputType="INPUT_REACT_SELECT_MODAL"
                                placeholder="Choose Month"
                                className="form-control w-100"
                                name="state_id"
                                id="state_id"
                                options={months}
                                value={months.filter(
                                  (item: any) =>
                                    getValue(item, `value`, "") ==
                                    (getValue(params, `month`, "")
                                      ? getValue(params, `month`, "")
                                      : new Date().getMonth() + 1)
                                )}
                                onChange={(e: any) =>
                                  handleChangeDate(
                                    getValue(e, `value`, ""),
                                    "month"
                                  )
                                }
                                isClear
                              />
                            </div>
                          </div>
                        </div>
                        &nbsp;&nbsp;&nbsp;
                        <div className="input-grid-item mt-0">
                          <div className="filter-form-wrappper__location-form-group form-group mb-0">
                            {/* <label
															htmlFor="State"
															className="filter-form-wrappper__label"
														>
															License Type
														</label> */}
                            <div className="filter-form-wrappper__location-input">
                              <InputField
                                inputType="INPUT_REACT_SELECT_MODAL"
                                placeholder="Choose License Type"
                                className="form-control w-100"
                                name="state_id"
                                id="state_id"
                                options={licenseTypeList}
                                value={licenseTypeList.filter(
                                  (item: any) =>
                                    getValue(item, `id`, "") ==
                                    (getValue(params, `license_type_id`, "")
                                      ? getValue(params, `license_type_id`, "")
                                      : selectedLicenseType)
                                )}
                                onChange={(e: any) =>
                                  handleChangeDate(
                                    getValue(e, `id`, ""),
                                    "license_type_id"
                                  )
                                }
                                isClear
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="dashboard-compliance__table d-flex my-4">
                <div className="flex-1">
                  <h3 className="dashboard-compliance__title">
                    Current License Stats
                  </h3>
                  <div className="license-current-license-stats-table-wrap rounded">
                    <table className="compliance-table">
                      <thead>
                        <tr>
                          <th>License Type</th>
                          <th>Followup Today</th>
                          <th>New</th>
                        </tr>
                      </thead>

                      <tbody>
                        {getValue(licenseStats, `length`, 0) > 0 ? (
                          licenseStats.map((item) => {
                            return (
                              <tr>
                                <td>{getValue(item, `license`, "")}</td>
                                <td>
                                  {getValue(
                                    item,
                                    `data.followup_today.count`,
                                    ""
                                  )}
                                </td>
                                <td>{getValue(item, `data.new.count`, "")}</td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={3} className="text-center">
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* <div className="view-more d-flex align-items-center justify-content-end cursor-pointer">
										<h6 className="view-nore-title">VIEW MORE</h6>
										<img
											src="/images/dashboard/vender-audit/forward-blue.svg"
											className="img-fluid"
										/>
									</div> */}
                </div>
                <div className="flex-1"></div>
              </div>
            </div>
          </div>
          {/* <div className="text-right">
						<img src="/images/profile-illustration.svg" className="img-fluid" />
					</div> */}
        </>
      )}
    </DashboardLayout>
  );
}
